<template>
    <!-- <div> -->
        <v-app>
            <v-content>
                <v-container style="background-image: url(https://petraplat.com/images/workshop_login.jpg); background-repeat: no-repeat;background-size: cover;" class="fill-height" fluid>
                    <v-row
                        align="center"
                        justify="center">
                        <v-col cols="12" sm="7" xs="4" md="3">
                            <v-card dark style="opacity: 0.9;">
                                <v-card-title>
                                    {{ $t("LOGIN_TITLE") }}
                                    <v-spacer></v-spacer>
                                    <!-- <v-select
                                        style="max-width: 150px"
                                        hide-details
                                        solo
                                        dense
                                        :items="locales"
                                        item-value="code"
                                        item-text="name"
                                        @change="changeLocale"
                                        v-model="localeSelect">
                                    </v-select> -->
                                </v-card-title>
                                <v-card-text>
                                    <div class="text-center">
                                        <v-progress-circular
                                            indeterminate
                                            v-if="!dataLoaded"
                                            color="primary">
                                        </v-progress-circular>
                                    </div>
                                    <v-form
                                        v-if="dataLoaded"
                                        ref="form"
                                        v-model="valid"
                                        >
                                        <v-select
                                            :label="$t('WORKSHOP_NAME')"
                                            v-model="loginForm.workshop_id"
                                            :rules="workshopRules"
                                            :items="workshops"
                                            :menu-props="{ down: true,offsetY: true}"
                                            item-text="name"
                                            item-value="id">
                                        </v-select>
                                        <v-text-field
                                            :label="$t('USER_USERNAME')"
                                            v-model="loginForm.username"
                                            required
                                            :rules="usernameRules"
                                            >
                                        </v-text-field>
                                        <v-text-field
                                            :label="$t('USER_PASSWORD')"
                                            v-model="loginForm.password"
                                            required
                                            :rules="passwordRules"
                                            type="password"
                                            >
                                        </v-text-field>
                                    </v-form>
                                    <p style="color:red;">{{loginErrorMessage}}</p>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        :disabled="!valid || loading.submit"
                                        color="primary" 
                                        @click="performLogin"
                                        :loading="loading.submit">
                                            {{ $t('BTN_LOGIN') }}
                                        </v-btn>
                                    <v-btn
                                        @click="resetValidation">
                                            {{ $t('RESET_FORM') }}
                                        </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-content>
        </v-app>
    <!-- </div> -->
</template>

<script>
import { mapActions, mapState } from 'vuex';
import i18n from '../plugins/i18n';
export default {
    name: "Login",
    props: {
        display: Boolean
    },
    data() {
        return {
            loginForm: {
                username: null,
                password: null,
                workshop_id: null
            },
            dataLoaded: false,
            valid: false,
            usernameRules: [
                v => !!v || this.$t("RULES_REQUIRED_MSG"),
            ],
            passwordRules: [
                v => !!v || this.$t("RULES_REQUIRED_MSG")
            ],
            workshopRules: [
                v => !!v || this.$t("RULES_REQUIRED_MSG")
            ],
            loading: {
                submit: false
            },
            localeSelect: null
        }
    },
    computed: {
        ...mapState('authentication', ['loginErrorMessage']),
        ...mapState("workshop", ["workshops"]),
        ...mapState(["locales", "locale"])
    },
    methods: {
        ...mapActions('authentication', ['login', "clearLoginErrorMessage", "getCurrentUser", "fetchAuthorizations"]),
        ...mapActions("workshop", ["fetchAll"]),
        ...mapActions(["setLocale"]),
        performLogin() {
            this.loading.submit = true;
            this.login(this.loginForm)
                .then(async () => {
                    this.resetValidation();
                    // this.$emit("login");
                    this.loading.submit = false;
                    this.display = false;
                    this.$router.push("/");
                    // this.$router.go();
                })
                .catch(() => {
                    this.loading.submit = false;
                });
        },
        resetValidation() {
            this.loginForm.username = null;
            this.loginForm.password = null;
            this.$refs.form.resetValidation()
            this.clearLoginErrorMessage();
        },
        changeLocale() {
            this.setLocale(this.localeSelect);
            this.$vuetify.rtl = this.locales.find(each => each.code == this.locale).rtl;
            i18n.locale = this.locale;
        }
    },
    async created() {
        this.localeSelect = this.locale;
        this.$vuetify.rtl = this.locales.find(each => each.code == this.locale).rtl;
        i18n.locale = this.locale;
        if(this.workshops.length == 0) await this.fetchAll();
        this.dataLoaded = true;
    }
}
</script>

<style>

</style>